import { render } from "./FreebetInfo.vue?vue&type=template&id=50e4c6a8"
import script from "./FreebetInfo.vue?vue&type=script&lang=js"
export * from "./FreebetInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__